// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"f6fc7010","256":"b83eeaa4","276":"c592be7e","338":"b83eeaa4"}[chunkId] + ".chunk.css";
};